<template>
  <div :class="{ 'navigation-menu-item--extra-margin': !title }" class="navigation-menu-item">
    <div class="navigation-menu-item__heading">
      <h2 v-if="title" class="navigation-menu-item__title">
        {{ title }}
      </h2>
      <img
        v-if="iconSource"
        class="navigation-menu-item__icon"
        :src="iconSource"
        alt="icon-menu-item"
        role="button"
        tabindex="0"
        @click="$emit('onIconClick')"
        @keydown.enter="$emit('onIconClick')"
        @keydown.space="(event) => handleSpaceKey(event, 'onIconClick')"
      />
      <img
        v-if="closeable"
        :src="iconCrossWhite"
        alt="icon-close"
        class="navigation-menu-item__cross"
        role="button"
        tabindex="0"
        @click="$emit('close')"
        @keydown.enter="$emit('close')"
        @keydown.space="(event) => handleSpaceKey(event, 'close')"
      />
    </div>
    <slot />
  </div>
</template>
<script setup lang="ts">
import iconCrossWhite from '@/assets/icon-cross--white.svg'

defineProps<{
  title?: string
  closeable?: boolean
  iconSource?: string
}>()

const emit = defineEmits(['onIconClick', 'close'])

// Handles space key for accessibility
function handleSpaceKey(event: KeyboardEvent, emitName: 'onIconClick' | 'close') {
  event.preventDefault()
  emit(emitName)
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss' as old-variables;

.navigation-menu-item {
  margin-bottom: old-variables.$margin-drop-down-item;
  &--extra-margin {
    margin-top: old-variables.$margin-small;
  }
  &__heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__title {
    color: old-variables.$color-text-white;
  }
  &__icon {
    height: 24px;
    cursor: pointer;
  }
  &__cross {
    transform: rotate(45deg);
  }
}
</style>
